/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/recommendTwoFactor.scss';

import {AwesomeIcon, CloseButton, CustomAppEvent, navigate, WithBackground, WithEvents} from '@dvrd/dvr-controls';

import React, {PureComponent} from 'react';

import {BolmateButton} from '../../controls';

interface State {
    active: boolean;
}

export default class RecommendTwoFactor extends PureComponent<any, State> {
    private readonly event: CustomAppEvent;

    constructor(props: any) {
        super(props);
        this.state = {
            active: false
        };
        this.event = {eventName: 'onRecommend2Fa', handler: this.onActivate};
    }

    onActivate = () => {
        this.setState({active: true});
    };

    onClose = () => {
        this.setState({active: false});
    };

    onNavigate = () => {
        this.setState({active: false}, () => {
            navigate('/instellingen/beveiliging');
        });
    };

    render = () => {
        const {active} = this.state;
        return (
            <WithEvents events={this.event}>
                <WithBackground active={active} onClose={this.onClose}>
                    <div className='recommend-two-factor'>
                        <div className='header-container'>
                            <label className='header-title'>Tweestapsverificatie</label>
                            <CloseButton onClick={this.onClose} />
                        </div>
                        <div className='body-container'>
                            <AwesomeIcon name='shield-alt' className='shield' />
                            <p className='text'>
                                We raden aan om gebruik te maken van tweestapsverificatie als extra beveiligingslaag
                                voor je account. Met tweestapsverificatie kunnen anderen geen toegang krijgen tot je
                                account, zelfs als ze je wachtwoord weten. Je kunt de tweestapsverificatie aan en uit
                                zetten via de instellingen.
                            </p>
                        </div>
                        <div className='footer-container'>
                            <BolmateButton onClick={this.onClose} label='Nee, bedankt' secondary />
                            <BolmateButton onClick={this.onNavigate} label='Instellen' />
                        </div>
                    </div>
                </WithBackground>
            </WithEvents>
        );
    };
}
